import React, { FC } from 'react';
import {
  Avatar,
  Box,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import defaultImage from '../../../../assets/defaultAvatar.png';
import { formatRoles } from '../../../../utils/user';
import CustomDetailItem from '../../../../common/components/CustomDetailItem/CustomDetailItem';
import { IUserEditState } from '../utils';
import { APAS, Role } from '../../../../common/constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      height: 80,
      width: 80,
      marginBottom: 10,
      alignSelf: 'center',
    },
    userName: {
      textAlign: 'center',
      color: '#1A171B',
      fontSize: 20,
      fontWeight: 'bold',
      marginBottom: 5,
    },
  }),
);

interface Params {
  avatarUrl: string | null;
  roles: string | string[];
  fullName: string;
  enseigneName: string;
  createdAt: string;
  mandataryFullName?: string;
  userState?: IUserEditState;
  setUserState?: React.Dispatch<React.SetStateAction<IUserEditState>>;
}

const UserDetailHeader: FC<Params> = (props) => {
  const {
    avatarUrl,
    roles,
    fullName,
    enseigneName,
    createdAt,
    mandataryFullName,
    userState,
    setUserState,
  } = props;
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Avatar
        src={avatarUrl || defaultImage}
        alt="Profile"
        className={classes.avatar}
      />
      <Typography className={classes.userName}>{fullName}</Typography>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12} sm="auto">
          <Typography>{enseigneName}</Typography>
          <Typography>{formatRoles(roles)}</Typography>
          {mandataryFullName && (
            <Typography>Mandataire référencé : {mandataryFullName}</Typography>
          )}
        </Grid>

        <Grid item xs={12} sm="auto">
          <CustomDetailItem name="Création" value={createdAt} />
          <CustomDetailItem name="idCC" value={userState?.userId?.toString()} />
          <CustomDetailItem<IUserEditState>
            mutationVariableName="idCRM"
            name="idCRM"
            value={userState?.idCRM?.toString()}
            editable={true}
            setState={setUserState}
          />
        </Grid>
      </Grid>
      <Box height={16} />
    </Box>
  );
};

export default UserDetailHeader;
